module.exports = __webpack_public_path__ + "phoenix-logo.png?ecef79b8cfcaa9e4719bfd3fcf2979ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoenix-logo.png
// module id = 170
// module chunks = 0